import React, {useEffect, useState} from "react";
import {Grid, Tooltip, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import OSEIndicador from "./OSEIndicador";
import clsx from "clsx";
import {format, parseISO} from "date-fns";
import {clickNewTab} from "../../../utils/utils";


const useStyles = makeStyles(theme => ({
  mainGrid: {
      flex: 1,

      flexBasis: "12.5%"
  },
  mainGridEtapas: {
      flex: 1,
      flexDirection: "row",
      flexWrap: "nowrap"
  }
}));




const OSBarras = ( { os } ) => {
    const classes = useStyles();

    let style = {}
    if (os.statusOrdemServicoId === 3 || os.statusOrdemServicoId === 7) {
        style = { color: 'red'}
    }

    const etapaAtual = os.processo.processoEtapas.find(pe => pe.id === os.etapaAtual);
    if (!etapaAtual) {
        console.log("ERROR processo etapa === etapaAtual nao encontrada.", os.id, os.processoId, os.ordemServicoId, os.etapaAtual)
    }
    const seqEtapaAtual = etapaAtual.sequencia;
    let legenda = "";
    const cli = os.cliente? os.cliente.descricao : "CLIENTE NAO REGISTRADO."

    try {


        legenda = <span>
                             `{os.ordemServicoId} - Pedido:({os.ordemServicoSequencia}) - {cli}`<br/>
                             `Chegada: {format(parseISO(os.DTChegada), "dd/MM HH:mm")} - Etapa Atual: {etapaAtual.descricao}`<br/>
                              `{os.pneuModelo.pneuFabricante.descricao} - {os.pneuModelo.descricao} - {os.pneuMedida.descricao}`<br/>
                              `Solicitada: {os.banda.descricao} `<br/>
                              `Aplicada: {os.itemBandaAplicada ? os.itemBandaAplicada.descricao : ''}`
                        </span>
    } catch (e) {
        console.log("TRY CATCH ERROR", etapaAtual, os);
        console.log(e);
    }




    return (
        <React.Fragment>
            <Grid container className={classes.mainGrid}>
                <Grid item>

                    <Tooltip title={legenda} aria-label="add">
                        <Typography style={style}  onClick={() => clickNewTab(`/ordemServico/${os.ordemServicoId}`) }>{os.ordemServicoId}</Typography>
                    </Tooltip>
                </Grid>
                <Grid container item className={classes.mainGridEtapas}>
                    {
                        os.processo && os.processo.processoEtapas && os.processo.processoEtapas.length > 0 &&
                        <React.Fragment>
                            <Grid container>
                                {
                                    os.processo.processoEtapas
                                        .filter(pe => pe.ehNaoVisivel === false)
                                        .sort(function (a, b) {
                                            var aSize = 1; //a.estabelecimentoId;
                                            var bSize = 1; //b.estabelecimentoId;
                                            var aLow = a.sequencia;
                                            var bLow = b.sequencia;
                                            // console.log(aLow + " | " + bLow);

                                            if(aSize == bSize)
                                            {
                                                return (aLow < bLow) ? -1 : (aLow > bLow) ? 1 : 0;
                                            }
                                            else
                                            {
                                                return (aSize < bSize) ? -1 : 1;
                                            }
                                        })
                                        .map( (pe, ixPe) => {
                                            if  (pe.oses) {
                                                return pe.oses.map( (ose, ixOse) => {
                                                     //console.log("oseIndicador para pe", os.ordemServicoId, pe.id, ose.id);
                                                    return (<OSEIndicador pe={pe} ose={ose} seqEtapaAtual={seqEtapaAtual} key={ixPe.toString()+'-'+ixOse.toString()}/>);
                                                })
                                            } else {
                                                //console.log("sem ose para pe", os.ordemServicoId, pe.id)
                                                return (<OSEIndicador pe={pe} ose={null} seqEtapaAtual={seqEtapaAtual} key={ixPe}/>);
                                            }
                                    })
                                }
                            </Grid>

                        </React.Fragment>
                    }
                </Grid>
            </Grid>
       </React.Fragment>
       );


}

export default OSBarras;
